import React from "react";
import PageTitle from "sc/ui/sites/oncall/components/PageTitle";
import { Row, Col, Panel } from "react-bootstrap";
import { connect } from "react-redux";
import { city } from "../../../selectors/cities";
import { cityPageLoad, cityAddRequest } from "../../../actions/cities";
import { push } from "react-router-redux";
import CityForm from "../../../components/forms/City";
import { regionsAvailableToCities } from "../../../selectors/regions";
import componentWithLoadTrigger from "sc/ui/components/hoc/componentWithLoadTrigger";

export default connect(
  (state, ownProps) => ({
    city: city(state),
    regions: regionsAvailableToCities(state),
  }),
  (dispatch, ownProps) => ({
    onLoad: () => dispatch(cityPageLoad()),
    onSave: formData => dispatch(cityAddRequest(formData)),
    onCityList: () => dispatch(push("/cities")),
  }),
)(
  componentWithLoadTrigger(props => {
    if (props.city === null) return <div />;
    return (
      <div id="add-city-page">
        <PageTitle title="Create City" />
        <div>
          <a id="back" style={{ cursor: "pointer" }} onClick={props.onCityList}>
            <span className="glyphicon  glyphicon-circle-arrow-left" />
            Back to cities list
          </a>
        </div>
        <br />
        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title componentClass="h3">City data</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Row>
              <Col md={8} mdOffset={2}>
                <CityForm
                  city={props.city}
                  regions={props.regions}
                  onSave={props.onSave}
                  disabled={props.city.generalDataSaveInProgress}
                  backendError={props.city.generalDataError}
                />
              </Col>
            </Row>
          </Panel.Body>
        </Panel>
      </div>
    );
  }),
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/partner-admin/cities/Add.js